import { Expedition, EditableStatuses, MetaLotOptionsTrans } from '@typings/entities/Expedition'
import { Eshop, EshopApi } from '@typings/entities/Eshop'

export const isExpeditionEditable = (
  expedition: Pick<Expedition, 'status' | 'waitBeforeProcessing'>,
  eshop?: Pick<Eshop | EshopApi, 'waitBeforeProcessing'>,
): boolean => {
  if (EditableStatuses.includes(expedition.status)) {
    return true
  }
  if (expedition.status == 'stock_ok') {
    const waitBeforeProcessing =
      expedition.waitBeforeProcessing !== null ? expedition.waitBeforeProcessing : eshop?.waitBeforeProcessing
    return !!waitBeforeProcessing
  }
  return false
}

export const isMetaLot = (lot?: string): boolean => {
  if (!lot) return false
  return MetaLotOptionsTrans()
    .map((lotOption) => lotOption.value)
    .includes(lot)
}
